/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_ConflictInputs */

const en_task_settings_conflict = /** @type {(inputs: Task_Settings_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These settings changed. The latest saved values are now shown.`)
};

const pt_br2_task_settings_conflict = /** @type {(inputs: Task_Settings_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estas configurações mudaram. Os valores salvos mais recentes estão sendo exibidos.`)
};

/**
* | output |
* | --- |
* | "These settings changed. The latest saved values are now shown." |
*
* @param {Task_Settings_ConflictInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_conflict = /** @type {((inputs?: Task_Settings_ConflictInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_ConflictInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_conflict(inputs)
	return pt_br2_task_settings_conflict(inputs)
});